import { render, staticRenderFns } from "./DeliveryConfirmationModal.vue?vue&type=template&id=e5661bb6&scoped=true&lang=pug&"
import script from "./DeliveryConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./DeliveryConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryConfirmationModal.vue?vue&type=style&index=0&id=e5661bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5661bb6",
  null
  
)

export default component.exports